import { ReactNode } from 'react'
import cn from 'classnames'

import CopyButton from 'components/ui/copy-button'

import styles from './styles.module.scss'

interface ICellHeading {
  children: ReactNode
  subinfo?: boolean
  subInfoSmall?: boolean
  copyButton?: boolean
  hiddenCopyButton?: boolean
  isCopied?: boolean
  onClick?: () => void
  className?: string
}

const CellHeading = ({
  children,
  subinfo,
  subInfoSmall,
  copyButton,
  hiddenCopyButton = false,
  isCopied,
  onClick,
  className,
}: ICellHeading) => {
  return (
    <h2
      className={cn(
        styles.heading,
        subinfo && styles.headingTypeSubinfo,
        subInfoSmall && styles.headingTypeSubInfoSmall,
        copyButton && styles.headingTypeCopy,
        className,
      )}
      onClick={onClick}
    >
      {children}
      {copyButton && <CopyButton isCopied={isCopied} hiddenCopyButton={hiddenCopyButton} />}
    </h2>
  )
}

export default CellHeading
